var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.logoContainer},[_c('img',{attrs:{"src":require("@/assets/img/Logo2.png"),"alt":"EZTaX Solver&reg;"}})])}
var staticRenderFns = []

export { render, staticRenderFns }